import LotteriesEnum from '@data/lotteries';
import getFormattedResult from '@helpers/getFormattedResult';

class BetModel {
  constructor (data, lotteryID) {
    this.bet = data.bet || ''
    this.betNumber = data.betNumber
    this.betNumberFormatted = (this.betNumber + '').padStart(5, '0')
    this.lotteryID = parseInt(lotteryID, 10)
    this.gameType = 'tens'
    this.key = null
    this.keyFormatted = null
    this.betPrize = data.betPrize || 0
    this.betFormatted = null
    this.inventoryCard = data.inventoryCard || null

    const lottery = LotteriesEnum.find((a) => a.id === this.lotteryID)

    if (lottery) {
      this.gameType = lottery.gameType
      this.betFormatted = getFormattedResult(this.bet, lottery.gameType)
      this.key = this.bet.split(' - ')[1] || null
      if (lottery.slug == 'keno-minas') {
        this.key = this.bet.split(' - ')[1].padStart(2, '0') || null
      }
      if (lottery.slug == 'mais-milionaria') {
        this.key = this.bet.split(' - ')[1] || null
        this.keyFormatted = getFormattedResult(this.key, lottery.gameType)
      }
    }
  }
}

export default BetModel
